module.exports = __webpack_public_path__ + "img/ic_guiding.9db1bfb8.png";